import { defineMessages } from '@cookbook/solid-intl'

export const messages = {
    accountLink: defineMessages({
        defaultMessage: 'Account',
        id: 'PublicTemplateComponent.accountLink',
    }),
    becomeAGuestButton: defineMessages({
        defaultMessage: 'Become a Guest',
        id: 'PublicTemplateComponent.becomeAGuestButton',
    }),
    becomeAHostButton: defineMessages({
        defaultMessage: 'Become a Host',
        id: 'PublicTemplateComponent.becomeAHostButton',
    }),
    bookingsLink: defineMessages({
        defaultMessage: 'Bookings',
        id: 'PublicTemplateComponent.bookingsLink',
    }),
    browserExtensionButton: defineMessages({
        defaultMessage: 'Browser Extension',
        id: 'PublicTemplateComponent.browserExtensionButton',
    }),
    calendarLink: defineMessages({
        defaultMessage: 'Calendar',
        id: 'PublicTemplateComponent.calendarLink',
    }),
    faqLink: defineMessages({
        defaultMessage: 'FAQ',
        id: 'PublicTemplateComponent.faqLink',
    }),
    faqsLink: defineMessages({
        defaultMessage: 'FAQ\'s',
        id: 'PublicTemplateComponent.faqsLink',
    }),
    guestSectionLabel: defineMessages({
        defaultMessage: 'Guest',
        id: 'PublicTemplateComponent.guestSectionLabel',
    }),
    hostSectionLabel: defineMessages({
        defaultMessage: 'Host',
        id: 'PublicTemplateComponent.hostSectionLabel',
    }),
    inboxLink: defineMessages({
        defaultMessage: 'Inbox',
        id: 'PublicTemplateComponent.inboxLink',
    }),
    languageAndCurrencyButton: defineMessages({
        defaultMessage: 'Language and Currency',
        id: 'PublicTemplateComponent.languageAndCurrencyButton',
    }),
    lodgrInsightsButton: defineMessages({
        defaultMessage: 'Lodgr Insights',
        id: 'PublicTemplateComponent.lodgrInsightsButton',
    }),
    logOutLink: defineMessages({
        defaultMessage: 'Log Out',
        id: 'PublicTemplateComponent.logOutLink',
    }),
    loginButton: defineMessages({
        defaultMessage: 'Login',
        id: 'PublicTemplateComponent.loginButton',
    }),
    newsroomButton: defineMessages({
        defaultMessage: 'Newsroom',
        id: 'PublicTemplateComponent.newsroomButton',
    }),
    noThanksButton: defineMessages({
        defaultMessage: 'No Thanks',
        id: 'PublicTemplateComponent.noThanksButton',
    }),
    openLodgrButton: defineMessages({
        defaultMessage: 'Open Lodgr',
        id: 'PublicTemplateComponent.openLodgrButton',
    }),
    openLodgrInNewTabAriaLabel: defineMessages({
        defaultMessage: 'Open Lodgr in a new tab',
        id: 'PublicTemplateComponent.openLodgrInNewTabAriaLabel',
    }),
    privacyLink: defineMessages({
        defaultMessage: 'Privacy Policy',
        id: 'PublicTemplateComponent.privacyLink',
    }),
    propertiesLink: defineMessages({
        defaultMessage: 'Your Listings',
        id: 'PublicTemplateComponent.propertiesLink',
    }),
    propertySearchButton: defineMessages({
        defaultMessage: 'Listing Search',
        id: 'PublicTemplateComponent.propertySearchButton',
    }),
    referralRecipientBannerTitle: defineMessages({
        defaultMessage: 'How was the signup process?',
        id: 'PublicTemplateComponent.referralRecipientBanner.title',
    }),
    referralRecipientFeedbackConfusing: defineMessages({
        defaultMessage: 'Confusing',
        id: 'PublicTemplateComponent.referralRecipientFeedback.confusing',
    }),
    referralRecipientFeedbackOkay: defineMessages({
        defaultMessage: 'Okay',
        id: 'PublicTemplateComponent.referralRecipientFeedback.okay',
    }),
    referralRecipientFeedbackSmooth: defineMessages({
        defaultMessage: 'Smooth',
        id: 'PublicTemplateComponent.referralRecipientFeedback.smooth',
    }),
    referralSenderBannerBody: defineMessages({
        defaultMessage: 'We\'re collecting feedback on Lodgr\'s referral system. Take a minute to share your thoughts.',
        id: 'PublicTemplateComponent.referralSenderBanner.body',
    }),
    referralSenderBannerTitle: defineMessages({
        defaultMessage: 'Have a moment?',
        id: 'PublicTemplateComponent.referralSenderBanner.title',
    }),
    referralsLink: defineMessages({
        defaultMessage: 'Referrals',
        id: 'PublicTemplateComponent.referralsLink',
    }),
    searchLink: defineMessages({
        defaultMessage: 'Search',
        id: 'PublicTemplateComponent.searchLink',
    }),
    staysLink: defineMessages({
        defaultMessage: 'Stays',
        id: 'PublicTemplateComponent.staysLink',
    }),
    takeSurveyButton: defineMessages({
        defaultMessage: 'Take Survey',
        id: 'PublicTemplateComponent.takeSurveyButton',
    }),
    termsLink: defineMessages({
        defaultMessage: 'Terms & Conditions',
        id: 'PublicTemplateComponent.termsLink',
    }),
}




